// import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
  login: { // 登录页面
    dlym01: 'Welcome Sign In',
    dlym02: 'No account yet?',
    dlym03: 'Register now',
    dlym04: 'Enter username',
    dlym05: 'Enter password',
    dlym06: 'Remember password',
    dlym07: 'Forget password',
    dlym08: 'SIGN IN',
    dlym09: 'SIGNING',
    dlym10: 'Login succeeded', // 未翻译
    dlym11: 'No data',
    dlym12: 'Got it',
    dlym13: 'Log out success'
  },
  register: { // 注册页面
    zcym01: 'Welcome Register',
    zcym02: 'Already have an account',
    zcym03: 'Log in',
    zcym04: 'Enter username',
    zcym05: 'Enter password',
    zcym06: 'Comfirm password',
    zcym07: 'Referral code(optional)',
    zcym08: 'REGISTER',
    zcym09: 'Customer Service',
    zcym10: 'In registration...', // 未翻译
    zcym11: 'Please enter a combination of 6 to 20 lowercase letters, uppercase letters, and numbers', // 未翻译
    zcym12: 'The password settings are inconsistent twice' // 未翻译
  },
  vip: {
    vip01: 'VIP Details',
    vip02: 'total bets',
    vip03: 'weekly bets',
    vip04: 'weekly bonus',
    vip05: 'Cashback  Proportion',
    vip06: 'game type',
    vip07: 'game',
    vip08: 'cashback'
  },
  yjjlbl: {
    yjjlbl01: 'Commission Proportion',
    yjjlbl02: 'subordinates vip',
    yjjlbl03: 'your  commission'
  },
  szcmlx: {
    szcmlx01: 'Set chip type',
    szcmlx02: 'USDT Chip',
    szcmlx03: 'RMB Chip',
    szcmlx04: "don't prompt today",
    szcmlx05: "don't prompt in 7 days ",
    szcmlx06: 'commit',
    szcmlx07: 'confirm',
    szcmlx08: 'To ensure the security of your account and funds, please bind your email address'
  },
  yqhy: {
    yqhy01: 'TG share link',
    yqhy02: 'Web share link',
    yqhy03: 'Share code',
    yqhy04: 'up to ',
    yqhy05: ' bets cashback',
    yqhy06: 'copy',
    yqhy07: 'someone click link will be your subordinates',
    yqhy08: 'New Direct subordinates',
    yqhy09: 'Direct subordinates',
    yqhy10: 'copy sucess',
    yqhy111: 'Invite friends',
    yqhy11: 'earn up to',
    yqhy12: 'commission rebate',
    yqhy13: 'Referral',
	  yqhy14: 'Single-click sharing',
    yqhy15: '分享至',
    yqhy16: '飞机一键分享',
    yqhy17: '复制飞机链接',
    yqhy18: '复制网页推荐链接',
    yqhy19: 'WhatsApp一键分享'
  },
  contact: {
    lxkf01: 'Online Service',
    lxkf02: 'Telegram',
    lxkf03: 'Official Channel',
    lxkf04: 'Consult',
    lxkf05: 'TG VIP Service',
    lxkf06: '24 hours online service',
    lxkf07: 'serve wholeheartedly for you'
  },
  bottomTab: {
    zmk01: 'Home',
    zmk02: 'Promotion',
    zmk03: 'Referral',
    zmk04: 'Account',
    zmk05: 'Please log in', // 未翻译
    zmk06: 'Recomand',
    zmk07: 'Menu',
    zmk08: 'Customer',
    zmk09: 'user does not exist',
    zmk10: 'Tip',
    zmk11: "You haven't logged in yet, please log in",
    zmk12: 'Home',
    zmk13: 'Customer',
    zmk14: 'Download'
  },
  home: { // 首页
    sy01: 'SIGN IN',
    sy02: 'SIGN UP', // 有误
    sy03: 'Deposit',
    sy04: 'Withdraw',
    sy05: 'Task',
    sy06: 'Income',
    sy07: 'Invite',
    sy08: 'My Bets',
    sy09: 'Hot Games',
    sy10: 'Slots',
    sy11: 'Table Games',
    sy12: 'Live Casino',
    sy13: 'Sports',
    sy131: 'Fishing',
    sy1311: 'Movie',
    sy132: 'Lotto',
    sy133: 'Hash',
    sy14: 'Instant Hash',
    sy15: '1min-Hash',
    sy37: "Don't pop up again",
    sy16: '',
    sy17: '',
    sy18: '',
    sy19: '',
    sy20: '',
    sy21: '',
    sy22: '',
    sy23: '',
    sy24: '',
    sy25: '',
    sy26: '',
    sy27: 'Select filter item',
    sy28: 'Game searching',
    sy29: 'Buy Crypto',
    sy30: 'Recommend VPN',
    sy31: 'HTX',
    sy32: 'BINANCE',
    sy33: 'OKEX',
    sy34: 'ZB',
    sy35: 'Partners and Industry Associations',
    sy36: 'Legal Gaming License',
    sy38: 'Add to home screen', // 未翻译
    sy39: 'All',
    sy40: 'Hot',
    sy41: 'Cancel',
    sy42: 'Please waiting'
  },
  czym: { // 充值页面
    czym01: 'Deposit',
    czym02: 'Account Deposit',
    czym03: 'Supported Crypto',
    czym04: 'USDT',
    czym05: 'HUIONE-BYEX',
    czym06: 'Online Wallet',
    czym07: 'Wallet Address',
    czym08: 'Copy Address',
    czym09: 'Copied',
    czym10: 'Minimun deposit amount 10U',
    czym111: 'Tip:',
    czym11: 'Make sure that the network you use for trading is the TRON network and the protocol used is the TRC20 protocol。',
    czym12: 'Select payment way',
    czym121: '', // 未翻译
    czym13: 'HW Scan',
    czym14: 'HW App',
    czym15: 'Account name',
    czym16: 'Account no',
    czym17: 'Copy',
    czym18: 'Contact online service to top up',
    czym19: 'Please transfer money to the above account through the Huione APP  transfer function.',
    czym20: 'USD top-up amount is converted to USDT 1:1, minimum top-up amount is $10.',
    czym21: 'Please enter the recharge amount',
    czym22: 'You can choose the recharge amount',
    czym23: 'comfirm',
    czym24: 'Recharge Amount',
    czym25: 'This QR code is valid util Beijing time:',
    czym26: 'The QR code is valid for 10 minutes, please scan the code to complete the recharge through the HUIONE APP  before it expires.',
    czym27: 'Return',
    czym28: 'USD top-up amount is converted to USDT 1:1, minimum top-up amount is $10.',
    czym29: 'Account name',
    czym30: 'Account no',
    czym31: 'Copy',
    czym32: 'Contact online service to top up',
    czym33: 'Please transfer money to the above account through the BYEX APP  transfer function.',
    czym34: 'USD top-up amount is converted to USDT 1:1, minimum top-up amount is $10.',
    czym35: 'recharge success', // 未翻译
    czym36: 'Pay',
    czym37: 'Pay by qrcode',
    czym38: 'currently you are a restricted user. Please contact online ',
    czym39: 'customer service',
    czym40: ' to change your user status before recharging, in order to activate withdrawal, cashback and other functions!',
    czym41: 'USDT',
    czym42: 'This currency is not currently supported',
    czym43: 'BYEX',
    czym44: 'Please download HUIONE APP',
    czym45: 'Please download BYEX APP',
    czym46: 'recharge way',
    czym47: 'amount/status',
    czym48: 'withdrawal way',
    czym50: 'After recharge need to bet',
    czym51: 'times amount before Withdrawal',
    czym52: 'Check if funded >',
    czym53: 'Checking···',
    czym54: 'USDT deposit successful！',
    czym55: 'Deposit amount：',
    czym56: 'Updated balance：',
    czym57: 'Keep deposti',
    czym58: 'Retrun home（',
    czym59: 'Not yet funded？',
    czym60: 'Please contact CSKH',
    czym61: 'Please contact CSKH',
    czym62: 'Deposit Time：',
    czym63: 'Please contact CSKH',
  },
  txym: { // 提现页面
    txym01: 'Withdraw',
    txym02: 'Web Withdraw',
    txym03: 'TG Withdraw',
    txym04: 'Account Withdraw',
    txym05: 'Supported crypto',
    txym06: 'USDT',
    txym07: 'USD-HUIONE',
    txym08: 'BYEX',
    txym09: 'Your wallet address',
    txym10: 'Add address',
    txym11: 'Withdraw amount',
    txym12: 'Lefted bet amount',
    txym13: 'Minimun withdraw amount',
    txym14: 'All',
    txym15: 'Account balance',
    txym16: 'Withdraw password',
    txym17: 'Set withdraw Password',
    txym18: 'Minimum withdraw amount is 10U, single withdraw fee is 0U',
    txym19: 'You can withdraw cash only when lefted bet amount is 0, otherwise you need to complete the lefted bet amount',
    txym191: "The current hash and PC28 related games' bets do not generate consumption flow, but normally generate betting flow",
    txym20: 'Withdraw Money',
    txym21: 'HUIONE account name',
    txym211: 'Please enter/select address',
    txym22: 'Please enter huione name(e.g.',
    txym23: 'HUIONE account no',
    txym24: 'Please enter huione no(e.g.',
    txym25: 'Withdraw amount',
    txym26: 'Lefted bet amount',
    txym27: 'Minimum withdraw amount',
    txym28: 'All',
    txym29: 'Account balance',
    txym30: 'Withdraw password',
    txym31: 'Set withdrawal Password',
    txym32: 'Minimum withdraw amount is 10U, single withdraw fee is 0U',
    txym33: 'You can withdraw cash only when lefted bet amount is 0, otherwise you need to complete the lefted bet amount',
    txym34: 'Withdraw Money',
    txym35: 'BYEX account name',
    txym36: 'Please enter BYEX name(eg.',
    txym37: 'BYEX account no',
    txym38: 'Please enter BYEX no(eg.',
    txym39: 'Withdraw amount',
    txym40: 'Lefted bet amount',
    txym41: 'Minimum withdraw amount',
    txym42: 'All',
    txym43: 'Account balance',
    txym44: 'Withdraw password',
    txym45: 'Set withdrawal Password',
    txym46: 'Minimum withdraw amount is 10U, single withdraw fee is 0U',
    txym47: 'You can withdraw cash only when lefted bet amount is 0, otherwise you need to complete the lefted bet amount',
    txym48: 'Withdraw Money',
    txym49: 'Account Withdraw',
    txym50: 'Supported crypto',
    txym51: 'Account balance',
    txym52: 'Minimum withdraw amount is 10U, single withdraw fee is 0U',
    txym53: 'Ensure the safe arrival of the funds, please withdraw the funds through the official telegram robot',
    txym54: 'Withdraw(Will Open TG)',
    txym55: 'Enter your withdrawal password',
    txym56: 'Confirm your withdrawal password',
    txym57: 'Please enter email verification code',
    txym58: 'Usable',
    txym59: 'Hw Wallet',
    txym60: 'BYEX Wallet',
    txym61: 'Your phone area code',
    txym62: 'Please enter your phone area code(Such as',
    txym63: 'Your phone number',
    txym64: 'Please enter your phone number(Such as',
    txym65: 'Please enter your huione name',
    txym66: 'Please enter your phone area code',
    txym67: 'Please enter your phone number',
    txym68: 'bind address',
    txym69: 'Friendly Reminder',
    txym70: 'For security, please set your withdrawal password！',
    txym71: 'set your withdrawal password'
  },
  rwzx: { // 任务中心
    rwzx01: 'Task',
    rwzx02: 'Attend',
    rwzx03: 'Claim',
    rwzx04: 'Unavailable',
    rwzx05: 'Claimed',
    rwzx06: 'Available'
  },
  wdsr: { // 我的收入
    wdsr01: 'My Income',
    wdsr02: 'Direct Performance',
    wdsr03: 'Cashback rewards',
    wdsr04: 'Claim',
    wdsr05: 'Claimed',
    wdsr06: 'No cashback rewards',
    wdsr07: '1% bets cashback',
    wdsr08: 'All bets',
    wdsr09: 'Valid bets',
    wdsr10: 'Cashback settlement',
    wdsr11: 'Details',
    wdsr12: 'Cashback records',
    wdsr13: 'Apply time',
    wdsr14: 'Amount',
    wdsr15: 'Status',
    wdsr16: 'No More',
    wdsr17: 'Yesterday',
    wdsr18: 'Today',
    wdsr19: 'Total',
    wdsr20: 'Commission rewards',
    wdsr21: 'Claim',
    wdsr22: '0.4% bets commission',
    wdsr23: 'Direct subordinates',
    wdsr24: 'New Direct subordinates',
    wdsr25: 'Commission  settlement',
    wdsr26: 'Details',
    wdsr27: 'Yesterday',
    wdsr28: 'Today',
    wdsr29: 'Total',
    wdsr30: 'Direct performance',
    wdsr31: 'Details',
    wdsr32: 'Commission records',
    wdsr33: 'Today performance',
    wdsr34: "Agency commission is settled on a daily basis, and yesterday's commission is  settled after 2am Singapore time",
    wdsr341: 'The commission is settled in real-time mode, and the delayed synchronization of data from third-party game providers may result in a delay of 10 to 20 minutes in settlement',
    wdsr35: 'Performance query',
    wdsr36: 'Game type',
    wdsr37: 'Performance',
    wdsr38: 'Proportion',
    wdsr39: 'Hash',
    wdsr40: 'Slots',
    wdsr41: 'Table Games',
    wdsr42: 'Live Casino',
    wdsr43: 'Sports',
    wdsr44: 'Toady',
    wdsr45: 'Yesterday',
    wdsr46: 'Name',
    wdsr47: 'Amount',
    wdsr48: 'TG no',
    wdsr49: 'up to ',
    wdsr50: '% >',
    wdsr51: 'up to ',
    wdsr52: '%',
    wdsr53: 'Hot Games',
    wdsr54: 'Your tg share link',
    wdsr55: 'Other share link',
    wdsr56: 'type',
    wdsr57: 'change/balance'
  },
  tzjl: { // 投注记录
    tzjl01: 'My Bets Records',
    tzjl02: 'Total bets',
    tzjl03: 'Bets',
    tzjl04: 'Profit',
    tzjl05: 'Bet Amount',
    tzjl06: 'Vaild Bets',
    tzjl07: 'Bets record',
    tzjl08: 'Hash Games',
    tzjl09: 'Slots',
    tzjl10: 'Table Games',
    tzjl11: 'Live Casino',
    tzjl12: 'Sports',
    tzjl13: 'Bet details',
    tzjl14: 'Total bets',
    tzjl15: 'Vaild bets',
    tzjl16: 'Profit',
    tzjl17: 'Total bets',
    tzjl18: 'Vaild bets',
    tzjl19: 'Profit',
    tzjl20: 'Bet no',
    tzjl21: 'Participated game',
    tzjl22: 'Betting area',
    tzjl23: 'Winning situation',
    tzjl24: 'Betting amount',
    tzjl25: 'Payout amount',
    tzjl26: 'Issued no',
    tzjl27: 'Wallet address',
    tzjl28: 'Hash key',
    tzjl29: 'Bet time',
    tzjl30: 'Verify',
    tzjl31: 'Total bets',
    tzjl32: 'Vaild bets',
    tzjl33: 'Profit',
    tzjl34: 'Bet no',
    tzjl35: 'Participated game',
    tzjl36: 'Bet time',
    tzjl37: 'Betting amount',
    tzjl38: 'Valid bets',
    tzjl39: 'Winning situation',
    tzjl40: 'Settle or not',
    tzjl41: 'Award Num',
    tzjl42: 'Bet Area',
    tzjl43: 'Winning Situation',
    tzjl44: 'Betting Amount',
    tzjl45: 'Payout Amount',
    tzjl46: 'Issued Num',
    tzjl47: 'Award Num',
    tzjl48: 'Bet Time',
    tzjl49: 'game name',
    tzjl50: 'loading...',
    tzjl51: 'pulling loading...',
    tzjl52: 'loosing loading...'
  },
  mywd: { // 我的
    wd01: 'Invite',
    wd02: 'My Income',
    wd03: 'My Bets',
    wd04: 'Security',
    wd05: 'Deposit',
    wd06: 'Withdraw',
    wd07: 'Total balance',
    wd08: 'Red Packet',
    wd09: 'Code Bonus',
    wd10: 'Profit Report',
    wd11: 'Balance Det',
    wd12: 'Transation',
    wd13: 'Affiliate',
    wd14: 'Buy Crypto',
    wd15: 'Vpn Download',
    wd16: 'Log out',
    wd17: 'Task',
    wd18: 'Safe Center',
    wd19: 'Balance',
    wd20: 'up to ',
    wd21: 'bets commission',
    wd22: 'details',
    wd23: 'copy',
    wd24: 'Chip Switch',
    wd25: 'Language'
  },
  aqzx: { // 安全中心
    aqzx01: 'Comprehensive protection of your account security',
    aqzx02: 'Set log in account',
    aqzx03: 'Set email',
    aqzx04: 'Modify email',
    aqzx05: 'Modify  log in password',
    aqzx06: 'Set withdraw password',
    aqzx07: 'Modify withdraw password',
    aqzx08: 'Bind withdraw wallet address',
    aqzx09: 'Please enter log in name',
    aqzx10: 'Please enter log in password',
    aqzx11: 'Please  comfirm log in password',
    aqzx12: 'Send',
    aqzx13: 'Please enter TG verification code',
    aqzx14: 'Please enter email',
    aqzx15: 'Please enter email verification code',
    aqzx16: 'Please enter log in password',
    aqzx17: 'In order to protect your account and fund security, please bind the email',
    aqzx18: 'Please enter new email',
    aqzx19: 'Commit',
    aqzx20: 'Please enter old  withdraw password',
    aqzx21: 'Please enter new  withdraw password',
    aqzx22: 'Please comfirm new  withdraw password',
    aqzx23: 'Commit',
    aqzx24: 'Forget password',
    aqzx25: 'Please enter old  log in password',
    aqzx26: 'Please enter new  log in password',
    aqzx27: 'Please comfirm new  log in password',
    aqzx28: 'Commit',
    aqzx29: 'Forget password',
    aqzx30: 'Add wallet address',
    aqzx31: 'Binded wallet address',
    aqzx32: '⊕  Add new address',
    aqzx33: 'Add new address',
    aqzx34: 'Select protocol',
    aqzx35: 'Add address',
    aqzx36: 'Please enter wallet address',
    aqzx37: 'Hint: For the safety of your funds, please make sure that the address you add is the same as the selected protocol.',
    aqzx38: 'Comfirm',
    aqzx39: 'Forget withdraw password',
    aqzx40: 'Please enter email',
    aqzx41: 'old Email',
    aqzx42: 'Please enter old email',
    aqzx43: 'Verification Code',
    aqzx44: 'Please enter verification code',
    aqzx45: 'new Email',
    aqzx46: 'Please enter new email',
    aqzx47: 'resend',
    aqzx48: 'Please enter correct email',
    aqzx49: 'Set successfully',
    aqzx50: 'TG Account',
    aqzx51: 'Email',
    aqzx52: 'Login Password',
    aqzx53: '',
    aqzx54: 'Old Password',
    aqzx55: 'New Password',
    aqzx56: 'The two passwords entered do not match',
    aqzx57: 'Sent successfully',
    aqzx58: 'Account',
    aqzx59: 'Please enter account',
    aqzx60: 'Withdrawal Password',
    aqzx61: 'Please enter Withdrawal Password'
  },
  wdhb: { // 我的红包
    hb01: 'Total balance',
    hb02: 'Send',
    hb03: 'Total amount',
    hb04: 'Number',
    hb05: 'Type',
    hb06: 'Bets need',
    hb07: 'Deadline',
    hb08: 'Lefted amount',
    hb09: 'Details',
    hb10: 'Red packet link',
    hb11: 'TG red packet link',
    hb12: 'Send TG red packet message',
    hb13: 'Notes',
    hb14: 'Send',
    hb15: 'Total amount',
    hb16: 'Number',
    hb17: 'Type',
    hb18: 'Turnover times',
    hb19: 'Deadline',
    hb20: 'Notes',
    hb201: 'Notes',
    hb21: 'Comfirm',
    hb22: 'Newcomer',
    hb23: 'All person',
    hb24: '1x',
    hb25: '2x',
    hb26: '3x',
    hb27: '4x',
    hb28: '5x',
    hb29: '1 day later',
    hb30: '2 day later',
    hb31: '3 day later',
    hb32: 'Newcomer red packet: all newcomers can claim; all person red packet: everyone can claim',
    hb33: 'times',
    hb34: 'no',
    hb35: 'share link',
    hb36: '10x'
  },
  hbkl: { // 红包口令
    hbkl01: 'Enter the code,pick up the red packet',
    hbkl02: 'Pick up'
  },
  sylb: { // 输赢列表
    sybb01: 'Statistics',
    sybb02: 'Time',
    sybb03: 'Bets',
    sybb04: 'Vaild Bets',
    sybb05: 'Profit',
    sybb06: 'Total Bets',
    sybb07: 'Total Profit',
    sybb08: 'The report is calculated based on the games profit and cashback'
  },
  ctjl: { // 充提记录
    ctjl01: 'Balance Record',
    ctjl02: 'Total balance',
    ctjl03: 'Order no',
    ctjl04: 'Initiation type',
    ctjl05: 'Recharge currency',
    ctjl06: 'Protocol',
    ctjl07: 'Service fee',
    ctjl08: 'Initiation amount',
    ctjl09: 'Credited amount',
    ctjl10: 'Transation hash',
    ctjl111: 'Address',
    ctjl112: 'remark',
    ctjl11: 'Initiation time',
    ctjl12: 'Withdraw  currency',
    ctjl13: 'Recharge Detail',
    ctjl14: 'Withdraw Detail'

  },
  jyjl: { // 交易记录
    jyjl01: 'Transation Record',
    jyjl02: 'Balance changes',
    jyjl03: 'Deposit',
    jyjl04: 'Withdraw',
    jyjl05: 'Bonus',
    jyjl06: 'Type',
    jyjl07: 'Charge/Balance'
  },
  gmhb: { // 购买货币
    gmhb01: 'Buy Crypto',
    gmhb02: 'Exchage',
    gmhb03: 'Download link',
    gmhb04: 'Turorial',
    gmhb05: 'View'
  },
  tjvpn: { // 推荐vpn
    tjvpn01: 'Software Downloads',
    tjvpn02: 'VPN Recommendations',
    tjvpn03: 'Rocket VPN',
    tjvpn04: '1.1.1.1 VPN',
    tjvpn05: 'Download',
    tjvpn06: 'Official Recommended Wallet',
    tjvpn07: 'In addition to  recommended exchanges, it is also possible to transfer money through decentralized wallets',
    tjvpn08: 'Other Downloads',
    tjvpn09: 'Official TG Robot',
    tjvpn10: 'TG Robot Turorial',
    tjvpn11: 'TG Robot'
  },
  hxhash: { // 哈希
    hx01: 'Integrated Hash',
    hx02: '1.95~9.7 times lottery  return',
    hx03: 'The last 1 digit (ignoring letters and decimal points) is used as the result of the lottery.',
    hx04: 'Issued no',
    hx05: 'Beted no',
    hx06: 'More issued no',
    hx07: 'Current bets',
    hx08: 'My bets',
    hx09: 'Game rules',
    hx10: 'limit',
    hx11: 'BIG',
    hx12: 'SMALL',
    hx13: 'ODD',
    hx14: 'EVEN',
    hx15: 'B&O',
    hx16: 'S&E',
    hx17: 'B&E',
    hx18: 'S&O',
    hx19: 'Enter the amount',
    hx20: 'Comfirm',
    hx21: 'Reset',
    hx22: 'Keep bets',
    hx23: 'Bets',
    hx24: 'Round',
    hx25: 'The top of the table is the latest data, the number represents the number of times the number in the column has not appeared, the red numbers are the current lottery numbers',
    hx26: 'B&O means big and odd,S&E means small and even,B&E means big and even,S&O means small and odd,O&E means odd and even,B&S means big and small',
    hx27: 'Number Trend',
    hx28: 'O&E Trend',
    hx29: 'B&S Trend',
    hx30: 'Successful bet',
    hx31: 'Beted no：',
    hx32: 'Sorry, you lost',
    hx33: "This period's result",
    hx34: 'Lottery no',
    hx35: 'Details',
    hx36: 'Hash key',
    hx37: 'Verify',
    hx38: 'I see',
    hx39: 'Manual mode',
    hx40: 'Betting area',
    hx41: 'Issued no',
    hx42: 'Betting amount',
    hx43: 'Winning amount',
    hx44: 'Verify hash key',
    hx45: 'Video leads how to verify hash key',
    hx46: 'View',
    hx47: 'Issued time',
    hx48: 'Issued no',
    hx49: 'Wallet address',
    hx50: 'Hash key',
    hx51: 'Issued status',
    hx52: "The platform relies on a decentralized blockchain network to randomly generate the wallet address data for the next 24 hours and 28,800 issues(3 seconds a period) as the source of the issues, and after the issues the wallet private key is published so that the players can verify it, so that the platform can't manipulate the data, and all the records are transparent and traceable.",
    hx53: 'Click copy wallet private key hash to open any decentralized wallet, import the wallet private key hash, check if the wallet address is the same as the wallet address given by the platform！',
    hx54: 'Issues query',
    hx55: 'Issued no',
    hx56: 'Enter issued no or wallet address',
    hx57: 'How to verify',
    hx58: 'Issued time',
    hx59: 'Issued no',
    hx60: 'Wallet address',
    hx61: 'Hash key',
    hx62: 'Unissued no',
    hx63: 'Click on the lottery issue number, wallet address, and lottery private key hash content to copy it',
    hx64: 'Total bets',
    hx65: 'Bets',
    hx66: 'Vaild bets',
    hx67: 'Profit',
    hx68: 'Bet no',
    hx69: 'Participated game',
    hx70: 'Betting area',
    hx71: 'Winning situation',
    hx72: 'Betting amount',
    hx73: 'Payout amount',
    hx74: 'Issued no',
    hx75: 'Wallet address',
    hx76: 'Hash key',
    hx77: 'Bet time',
    hx78: 'Verify',
    hx79: 'Hash Even/Odd',
    hx80: 'Hash Bullfight',
    hx81: 'Hash Big/Small',
    hx82: 'Hash Banker/Player',
    hx83: 'Luckey Hash',
    hx84: 'Dice Even/Odd',
    hx85: 'Dice Big/Small',
    hx86: 'Bull1',
    hx87: 'Bull2',
    hx88: 'Bull3',
    hx89: 'Bull4',
    hx90: 'Bull5',
    hx91: 'Bull6',
    hx92: 'Bull7',
    hx93: 'Bull8',
    hx94: 'Bull9',
    hx95: 'BullBull',
    hx96: 'BULL PLAYER',
    hx97: 'Tie',
    hx98: '2times lottery  return',
    hx99: '1.95times lottery  return',
    hx100: 'key hash value from right to left read 3 (1-6) numbers (repeatable) for each lottery number as the lottery result.',
    hx101: 'Deposit',
    hx102: 'B',
    hx103: 'S',
    hx104: 'O',
    hx105: 'E',
    hx106: 'Congratulations,you win',
    hx107: "This period's result",
    hx108: 'Direct mode',
    hx109: 'Hash1Min Even/Odd',
    hx110: 'Hash1Min Big/Small',
    hx111: 'Hash1Min Bull',
    hx112: 'Hash1Min Banker/Player',
    hx113: 'Hash1Min Lucky',
    hx114: 'Dice1Min Even/Odd',
    hx115: 'Dice1Min Big/Small',
    hx116: 'Integrated Hash1Min',
    hx117: 'All',
    hx118: 'last issued no',
    hx119: 'current no',
    hx120: 'history  no',
    hx121: 'verify',
    hx122: 'all bets'
  },
  yxgz: { // 游戏规则
    yxgz01: 'Lottery rules',
    yxgz02: 'In order to ensure the absolute fairness of the game,the platform in advance to randomly generate the next 24 hours',
    yxgz03: 'data (3 seconds a period), in order to ensure that the bet is unissued period, the system issue of interval of 20 period,the wallet private key hash (KEY hash) as a result of the lottery number!',
    yxgz04: ' 28800 period of the opening wallet address ',
    yxgz05: 'In order to ensure the absolute fairness of the game,the platform in advance to randomly generate ',
    yxgz06: 'next 24 hours 28800 period of the opening wallet address',
    yxgz07: '...,Based on the private key hash value from right to left read 3 (1-6) numbers (repeatable) for each lottery number, as the lottery result.',
    yxgz08: "1.The last 5 digits of the key hash value (key hash)  will be the card face, for example: key hash value (00057aba), the card face is '57aba', the letters are '10', and the sum of the individual digits is compared",
    yxgz09: '2.Card type algorithm: Ox1Ox10 corresponds to 110 times',
    yxgz10: "3.When the player's card type is Ox10, Ox9, a 10% service fee will be deducted when winning",
    yxgz11: "4.If the current banker is: 57a. 5+7+10=22 'Ox2'",
    yxgz12: "5.If the current player is: aba. 10+10+10=30 'Ox10'",
    yxgz13: '6.If the point values are the same, a 1% service fee will be deducted and the principal will be refunded',
    yxgz14: "1.The last 5 digits of the key hash value (Key hash)  will be the card face, for example: key hash value (000a3b78), the card face is 'a3b78'",
    yxgz15: "2.The banker's card face is the first 2 digits. The player's card face is the last 2 digits. 0 is the smallest, 9 is the largest, and letters (abc) are 0",
    yxgz16: '3.If the current banker is: a, 3. The value is 3',
    yxgz17: '4.If the current player is: 7, 8. The value is 5',
    yxgz18: '5.Bet on banker win, after comparing the points, if the banker wins, it will pay 1.95 times',
    yxgz19: '6.Bet on player win, after comparing the points, if the player wins, it will pay 1.95 times',
    yxgz20: '7.Bet on tie win, after comparing the points, if the tie wins, it will pay 8 times',
    yxgz21: "8.If you bet on banker or player, and it's a tie, the bet will be refunded ",
    yxgz22: '1.The last 2 digits of the private key hash (Key hash) of the opening wallet are a combination of numbers or letters for the win',
    yxgz23: "issued no 2023122500006's key hash is ",
    yxgz24: 'e.g:',
    yxgz25: 'data (3 seconds a period), in order to ensure that the bet is unissued period, the system issue of interval of 20 period,the wallet private key hash (KEY hash) as a result of the lottery number!',
    yxgz26: '1.The last 1 digit of the key hash  will be the lottery result (ignoring letters)',
    yxgz27: '2.Digits 0、1、2、3、4 are recognized as  small numbers',
    yxgz28: '3. Digits 5、6、7、8、9 are recognized as  big numbers',
    yxgz29: '2.Digits 1、3、5、7、9 are recognized as  odd numbers',
    yxgz30: 'Digits 0、2、4、6、8 are recognized as  even numbers',
    yxgz31: 'Size: The sum of three dice is even, and the sum of three dice is odd. Please note: If the first, second, and third dice have the same number of points, you will take the [Odd] and [Even] bets.',
    yxgz32: 'Size: The sum of  three dice is 3-10 for small, and the sum of three dice is 11-18 for big. Please note: If the first, second, and third dice have the same number of points, you will take the [Big] and [Small] bets.',
    yxgz33: 'Read the 3 (1-6) digits (repeatable) in order from right to left and the lottery numbers are ',
    yxgz34: 'the last 1 digit is ',
    yxgz35: '10. The special code is to choose a number for betting, the selected number and the lottery number is the same as the winning',
    yxgz36: '4.Digits 1、3、5、7、9 are recognized as  odd numbers',
    yxgz37: '5. Digits 0、2、4、6、8 are recognized as  even numbers',
    yxgz38: '6.Digits 0、2、4  are recognized as  small and even numbers',
    yxgz39: '7. Digits 6、8 are recognized as  big and even numbers',
    yxgz40: '8. Digits5、7、9  are recognized as  big and odd numbers',
    yxgz41: '9. Digits 1、3 are recognized as  small and odd numbers',
    yxgz42: 'then the lottery result is ',
    yxgz43: 'The last 2 digits are ',
    yxgz44: ',the lottery result is even',
    yxgz45: ',the lottery result is small',
    yxgz46: ', the lottery result is lucky!',
    yxgz47: '，result is big',
    yxgz48: 'The result is Big, Even, Big-Even, and the special number is'
  },
  cwm: {
    1: 'success',
    5555: 'Redirect failed',
    8888: 'The system is upgrading, please wait',
    9999: 'System error, please contact online service',
    1051: 'User does not exist',
    1052: 'Operation failed',
    1101: 'User id cannot be empty',
    1102: "The user's  U  address cannot be empty",
    1103: 'User name already exists',
    1104: 'Registration failed, please contact online service',
    1105: 'Account cannot be empty',
    1106: 'Password cannot be empty',
    1107: 'Please use an account number of 6-20 characters',
    1108: 'Please use a password of 6-20 characters',
    1109: 'The account format is incorrect, please re-enter',
    1110: 'The password format is incorrect, please re-enter',
    1111: 'The operation is too frequent. Please try later.',
    1112: 'The account or password is incorrect, login failed',
    1113: 'The account has been registered, please re-enter',
    1114: 'Registration failed,please contact online service',
    1115: 'Rebate setting error',
    1120: 'Activity code does not exist',
    1121: 'Please select recharge record',
    1122: 'Recharge record does not exists',
    1123: 'Recharge record error',
    1124: 'Activity is not available',
    1125: 'The recharge record does not meet the activity conditions',
    1126: 'The current recharge reward has been claimed and cannot be claimed again',
    1127: 'Failed to claim, please try again',
    1128: 'Please select the claim limit',
    1129: 'Claim limit error',
    1130: 'The current turnover is insufficient and does not meet the claim conditions',
    1131: 'This reward has been claimed and cannot be claimed again',
    1132: 'Exceeds the allowed limit, please place a new bet',
    1133: 'The withdrawal address cannot be empty',
    1134: 'Failed to claim, please try again',
    1135: 'Add failed, please try again',
    1136: 'Delete failed,please try again',
    1137: 'Withdrawal robot message push failed',
    1138: 'Failed to obtain Huione link',
    1139: 'Failed to save the huione payment order, please resubmit',
    1140: 'Huione recharge parameter configuration error',
    1141: 'Baiyi recharge parameter configuration error',
    1142: 'Address does not exist',
    1143: 'Failed to generate referral  link, please contact online service',
    1144: 'Failed to generate referral  link, please contact @XXXXXX',
    1145: 'Commission claim failed, please try again later',
    1146: 'No data found',
    1147: 'Failed to save system message',
    1148: 'Message push failed',
    1149: 'The red envelope was sent successfully, but the message push failed',
    1150: 'Binding failed, please contact online service',
    1151: 'Set failed, please try again',
    1152: 'Operation failed, please contact online service',
    1153: 'Failed to send email, please contact online service',
    1154: 'The same amount can only be claimed XXXXXX times within 24 hours',
    1155: 'The withdrawal address  length is incorrect',
    1156: 'The withdrawal address  starts incorrectly',
    1157: 'The withdrawal address format is incorrect',
    1158: 'The same  address already exists, and cannot be added repeatedly',
    1159: 'The withdrawal address format is incorrect',
    1160: 'The withdrawal address does not exist and cannot be deleted',
    1161: 'The withdrawal password has not been set yet. Please set  first',
    1162: 'Withdrawal password cannot be empty',
    1163: 'use a 6-20 character  password',
    1164: 'password format is incorrect',
    1165: 'Incorrect withdrawal password',
    1166: 'Withdrawal address cannot be empty',
    1167: 'The withdrawal information is too long',
    1168: 'Withdrawal amount cannot be empty',
    1169: 'Withdrawal type cannot be empty',
    1170: 'Withdrawal type error',
    1171: 'The amount format is incorrect, please reply again',
    1172: 'The amount is invalid, please reply again',
    1173: 'System error, please contact online service',
    1174: 'Amount conversion error',
    1175: 'Withdrawal failed, your balance is insufficient',
    1176: 'The withdrawal function is unavailable. Please submit again later',
    1177: 'The withdrawal address cannot be the internal recharge address , thank you',
    1178: 'withdrawal  failed',
    1179: 'Request error or incomplete information',
    1180: 'Withdrawal U address cannot be empty',
    1181: 'The withdrawal information is too long',
    1182: 'System error or incomplete information',
    1183: 'Block data error',
    1184: 'This game is temporarily suspended',
    1185: 'Wrong bet type',
    1186: 'The order amount is incorrect',
    1187: 'Exceeds the allowed  limit, please place a new bet',
    1188: 'Error in reading user balance ',
    1189: 'Insufficient user balance',
    1190: 'Block hash generation exception',
    1191: 'The block is abnormal, please re-order or consult online service',
    1192: 'The order failed, please place the order again',
    1193: 'Failed to read data',
    1194: 'The order number does not exist',
    1195: 'The table game menu type cannot be empty',
    1196: 'The table game type cannot be empty',
    1197: 'The  game menu type cannot be empty',
    1198: 'The table game menu type cannot be empty',
    1199: 'Block dice generation abnormality',
    1200: 'The current term  has been stopped for bet',
    1201: 'order failed, please place the order again or contact online service',
    1202: 'The  block code does not exist',
    1203: 'The open information does not exist or has not been drawn.',
    1204: 'Incorrect bet data',
    1205: 'The bet amount cannot be empty',
    1206: 'bet amount format error',
    1207: "bet amount is too much and  cannot't exceed XXXXXX",
    1208: 'The bet amount is too small and cannot be less than 10',
    1209: 'The format of the bet amount is incorrect, with a maximum of 2 decimal places',
    1210: 'Huione scanning parameter error',
    1211: 'Order number cannot be empty',
    1212: 'parameter cannot be empty',
    1213: 'claime type  is incorrect',
    1214: 'No commission available',
    1215: 'Please enter the query information',
    1216: 'Title information cannot be empty',
    1217: 'Content information cannot be empty',
    1218: 'Red envelope ID cannot be empty',
    1219: 'Red envelope information does not exist',
    1220: 'The total amount of the red envelope cannot be empty',
    1221: 'The format of the  amount of the red envelope is incorrect',
    1222: 'the  amount of the red envelope must be greater than 1',
    1223: 'The number of red envelopes cannot be empty',
    1224: 'The format of the number of red envelopes is incorrect',
    1225: 'The  amount of red envelopes cannot be less than the number of red envelopes',
    1226: 'Red envelope type cannot be empty or formatted incorrectly',
    1227: 'The activity red envelope must specify a user ID',
    1228: 'The maximum amount cannot be empty',
    1229: 'The maximum amount format is incorrect',
    1230: 'The maximum amount of a red envelope cannot be less than 1',
    1231: 'The minimum amount cannot be empty',
    1232: 'The minimum amount format is incorrect',
    1233: 'The minimum amount of a red envelope cannot be less than 1',
    1234: 'The minimum amount is greater than the maximum amount',
    1235: 'The deadline cannot be empty',
    1236: 'The deadline format is incorrect',
    1237: 'The deadline cannot be earlier than the current time',
    1238: 'Number logic error, [maximum amount] * [number of red envelopes] cannot be less than [total amount]',
    1239: 'Number logic error, [minimum amount] * [number of red envelopes] cannot be greater than [total amount]',
    1240: 'The required consumption multiple does not match',
    1241: 'Exceeding the red envelope limit you have set',
    1242: 'Failed to issue the package, please try again',
    1243: 'The activity reward has been distributed',
    1244: 'Insufficient turnover to participate in activities',
    1245: 'The user  does not exist',
    1246: "The user's balance  is insufficient",
    1247: "Failed to update the user's  turnover activitiy status",
    1248: 'Red envelope has expired',
    1249: 'Novice red envelopes can only be claimed by new members',
    1250: 'Red envelopes can only be claimed by subordinates',
    1251: 'This red envelope can only be claimed by designated members',
    1252: 'The red envelope has already been claimed',
    1253: 'The red envelope is unavailable',
    1254: 'The red envelope has been cancelled',
    1255: 'The red envelope has been expired',
    1256: 'Red envelope data query error',
    1257: 'The current user has already bound their email and cannot bind it again',
    1258: 'Email address cannot be empty',
    1259: 'The email address is incorrect',
    1260: 'The current email has been used by another user. Please change the email',
    1261: 'Email verification code cannot be empty',
    1262: 'Email verification code error',
    1263: 'Email verification code has expired',
    1264: 'The current user has not bound an email and cannot modify it',
    1265: 'Original email verification code error, binding failed',
    1266: 'The original email address cannot be empty',
    1267: 'The original email verification code cannot be empty',
    1268: 'The new email address cannot be empty',
    1269: 'The new email verification code cannot be empty',
    1270: 'The original email address is incorrect',
    1271: 'The original email address format is incorrect',
    1272: 'The new email address format is incorrect',
    1273: 'The current email has been bound by another user. Please change the email',
    1274: 'The original email verification code has expired, binding failed',
    1275: 'Original email verification code error, binding failed',
    1276: 'New email verification code error, binding failed',
    1277: 'The new email verification code has expired, binding failed',
    1278: 'The account has already been set up and cannot be set up again',
    1279: 'The withdrawal password has already been set and cannot be set again',
    1280: 'The username already exists, please re-enter',
    1281: 'The account password has not been set yet. Please set up the account first',
    1282: 'The original password cannot be empty',
    1283: 'The new password cannot be empty',
    1284: 'The original password format is incorrect',
    1285: 'The new password format is incorrect',
    1286: 'The original password  is incorrect',
    1287: 'password cannot be empty',
    1288: 'use a 6-20 character  password',
    1289: 'password format is incorrect',
    1290: 'password has not been set yet,set first',
    1291: 'old password cannot be empty',
    1292: 'new password cannot be empty',
    1293: 'old password format is incorrect',
    1294: 'new password format is incorrect',
    1295: 'old password is incorrect',
    1296: 'login password cannot be empty',
    1297: 'operation is too frequent,try later',
    1298: 'not been bound by the user,please change the mailbox',
    1299: 'bound the mailbox first',
    1300: 'Sending failed,please contact online service',
    1301: 'please enter a valid email address',
    1302: "Please claim the commission after 2 o'clock",
    1303: 'Exceeded the red envelope limit',
    1304: 'There is still XXXXXX unfinished in the consumption and  cannot do  withdraw temporarily',
    1305: 'withdrawal money cannot be less than XXXXXX',
    1306: 'Please complete the consumption demand',
    1307: 'Referral not exist',
    1308: 'The average of the red envelope cannot be less than 0.01',
    1309: 'The maximum withdrawal amount is 2 decimal places',
    1310: 'Incorrect login password',
    1311: 'Verification code cannot be empty',
    1313: 'TG verification code is incorrect',
    1314: 'Sorry, you do not have permission to send red envelopes',
    1315: 'The password  is too simple, please re-enter',
    1316: 'Sorry, the game is not available yet',
    1317: 'cannot modify the withdrawal address,please contact online service',
    1318: 'number format error',
    1319: 'Your balance is insufficient',
    1320: "This week's gift money has been claimed and cannot be repeated",
    1321: 'Insufficient valid bets this week, cannot be claimed',
    1322: 'no reward amount at the current vip and  cannot be claimed',
    1323: 'You have activated the monthly card and cannot activate it again',
    1324: 'the balance is insufficient',
    1325: 'Please activate the monthly card activity before claiming it',
    1326: 'The day rewards  have been claimed and cannot be claimed again',
    1327: 'Request parameter error',
    1328: 'There is no record of claim.',
    1329: 'Please claim the upper level reward first',
    1330: 'The withdrawal amount must be an integer',
    1331: 'Error in obtaining domain name information',
    1332: 'Huiwang QR code scanning is not supported yet',
    1333: 'Red envelopes can only be claimed in designated areas',
    1334: 'Exceeding the total limit XXXXXX',
    1335: 'The red envelope function is not yet available',
    1336: '',
    1337: '',
    1338: '',
    1339: '',
    1340: '',
    1341: '',
    1342: '',
    1343: '',
    1344: '',
    1345: '',
    1346: '',
    1347: '',
    1348: '',
    1349: '',
    1350: '',
    1351: '',
    1352: '',
    1353: '',
    1354: '',
    1355: '',
    1356: '',
    1357: '',
    1358: '',
    1359: '',
    1360: '',
    1361: '',
    1362: '',
    1363: '',
    1364: '',
    1365: '',
    1366: '',
    1367: '',
    1368: '',
    1369: '',
    1370: '',
    1371: '',
    1372: '',
    1373: '',
    1374: '',
    1375: '',
    1376: '',
    1377: '',
    1378: '',
    1379: '',
    1380: '',
    1381: '',
    1382: '',
    1383: '',
    1384: '',
    1385: '',
    1386: '',
    1387: '',
    1388: '',
    1389: '',
    1390: '',
    1391: '',
    1392: '',
    1393: '',
    1394: '',
    1395: '',
    1396: '',
    1397: '',
    1398: '',
    1399: '',
    1400: ''
  }
  // ...enLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
export default en
